export default __webpack_public_path__ + "static/media/g_05.3dde5185.png";